import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';
import {
  SignaturePad,
  type SignaturePadProps,
} from '../signature';

export type SignatureCaptureProps = SignaturePadProps & {
  /** Optional heading above the pad. */
  title?: string;
  className?: string;
  /** Constrain width for compact headers (e.g. crew edit). */
  compact?: boolean;
};

/**
 * Reusable signature capture (draw or upload) for any entity form.
 * Wraps the shared {@link SignaturePad}; parents supply upload + downloadPath.
 */
export const SignatureCapture: React.FC<SignatureCaptureProps> = ({
  title = 'Signature',
  className,
  compact = false,
  height,
  ...padProps
}) => {
  const { colors } = useTheme();
  return (
    <div
      className={cn(
        'space-y-1.5',
        compact && 'min-w-[200px] max-w-[280px]',
        className,
      )}
    >
      {title ? (
        <p className={cn('text-xs font-medium', colors.textMuted)}>{title}</p>
      ) : null}
      <SignaturePad {...padProps} height={height ?? (compact ? 112 : 160)} />
    </div>
  );
};

export default SignatureCapture;
